import React from 'react';

import LogoImages from 'js/src/components/common/LogoImages';
import { logoImagesDark } from 'js/src/components/public-pages/homepage-data';
import type { DeepReadonly } from 'js/src/libs/consts';

const ScrollingLogosComponent = React.memo(function ScrollingLogosComponent({
    data,
    bgColor,
    lazyLoad,
}: {
    data: DeepReadonly<Record<string, unknown>>;
    bgColor: string;
    lazyLoad: boolean;
}) {
    return (
        <div className="contentful-component scrolling-logos" style={{ backgroundColor: bgColor }}>
            <LogoImages logos={logoImagesDark} rows={2} lazyLoad={lazyLoad} />
        </div>
    );
});

export default ScrollingLogosComponent;
